import React from 'react';
import { apiGet, apiPost } from '../../../../services/apiClient';
import { getCurrentUserId, getRoles, getCurrentUserCompanyId } from '../../../../services/userRights';
import { isUndefined } from 'util';
import SectionForm from "../sectionForm";
import {Button, Checkbox, Form, Grid, Input} from "semantic-ui-react";
import Info from "../../../../components/Info";
import Dropdown from "../../../../components/Dropdown";
import InitiatorSearchDropdown from "../../../../components/Dropdowns/InitiatorSearchDropdown";
import ParcelCustomersManageModal from "../parcelCustomersManageModal";

export default class PayerTab extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            busyCount: 0,
            initiators: [],
            subCompanies: [],
            shipmentTypes: [],
            shipmentPurposes: [],
            products: [],
            regions: [],
            costCenters: [],
            glAccounts: [],
            parcelCustomers: [],
            userCompanies: [],
            userCompanyInitiators: [],
            initiatorsMeta: {},
            regionsMeta: {},
            productsMeta: {},
            glAccountsMeta: {},
            parcelCustomersModalOpen: false,
            editVm: {
                isVisibleInitiator: false,
                isVisibleSubCompany: false,
                isVisibleShipmentType: false,
                isVisibleShipmentPurpose: false,
                isVisibleProduct: false,
                isVisibleRegion: false,
                isVisibleGlAccount: false,
                isVisibleCostCenter: false,
                isVisibleUserCompany: false,
                isVisibleParcelCustomer: false,
                canEditInitiator: false,
                canEditSubCompany: false,
                canEditShipmentType: false,
                canEditShipmentPurpose: false,
                canEditProduct: false,
                canEditRegion: false,
                canEditCostCenter: false,
                canEditGlAccount: false,
                canEditUserCompany: false,
                isRequiredInitiator: false,
                isRequiredSubCompany: false,
                isRequiredShipmentType: false,
                isRequiredShipmentPurpose: false,
                isRequiredProduct: false,
                isRequiredRegion: false,
                isRequiredCostCenter: false,
                isRequiredGlAccount: false,
                isRequiredUserCompany: false,
                isRequiredParcelCustomer: false,
                canEditParcelCustomer: false
            }
        };

        this.lastCrossSector = undefined;
        this.lastSubCompanyId = undefined;
        this.lastShipmentTypeId = undefined;
        this.lastShipmentPurposeId = undefined;
        this.lastProductId = undefined;
        this.lastInitiatorId = undefined;
        this.lastCostCenterId = undefined;
        this.isLoadingUserCompanies = false;
    }

    updateBusyCount(inc) {
        this.setState((prevState, props) => {
            prevState.busyCount = prevState.busyCount + inc;
            return prevState;
        });
    }

    initParcelData(parcel) {
        parcel.payerTabVisible = false;
        parcel.initiatorId = null;
        parcel.isCrossSector = false;
        parcel.subCompanyId = null;
        parcel.initiatorIsCrossSector = false;
        parcel.initiatorSubCompanyId = null;
        parcel.shipmentTypeId = null;
        parcel.shipmentPurposeId = null;
        parcel.productId = null;
        parcel.activityCode = "";
        parcel.regionId = null;
        parcel.regionCode = "";
        parcel.costCenterId = null;
        parcel.glAccountId = null;
        parcel.parcelCustomerId = null;
        parcel.userCompanyId = null;
        return parcel;
    }

    shouldShowParcelCustomer() {
        if (this.state.editVm.isVisibleParcelCustomer) {
            return true;
        }
        return !this.props.isNew && !!this.props.parcel.parcelCustomerId;
    }

    isParcelCustomerEditable() {
        if (!this.state.editVm.isVisibleParcelCustomer) {
            return false;
        }
        const roles = getRoles();
        const isCoordinator = roles.indexOf('Coordinator') >= 0;
        const isOnlyBeforeSendEditable = this.props.isNew
            || this.props.parcel.statusCode === 'Created'
            || (this.props.parcel.statusCode === 'SentToMailRoom' && isCoordinator);
        if (!isOnlyBeforeSendEditable) {
            return false;
        }
        if (this.props.isNew) {
            return true;
        }
        return this.state.editVm.canEditParcelCustomer;
    }

    canManageParcelCustomers() {
        if (!this.state.editVm.isVisibleParcelCustomer) {
            return false;
        }
        // На оформленной посылке справочник — только при «Редактируемо»; при создании — достаточно «Видимо»
        if (!this.props.isNew && !this.state.editVm.canEditParcelCustomer) {
            return false;
        }
        const roles = getRoles();
        return roles.indexOf('Coordinator') >= 0
            || roles.indexOf('Author') >= 0
            || roles.indexOf('ClientAdmin') >= 0;
    }

    notifyValidationChange() {
        if (this.props.onValidationChange) {
            this.props.onValidationChange(this.validateForm());
        }
    }

    loadParcelCustomers() {
        const companyId = this.props.parcel.companyId;
        if (!companyId) {
            return Promise.resolve();
        }
        if (!this.state.editVm.isVisibleParcelCustomer && !this.props.parcel.parcelCustomerId) {
            return Promise.resolve();
        }
        this.updateBusyCount(1);
        return apiPost('ref/parcelcustomers/list', {companyId})
            .then(data => {
                const entries = ((data && data.entries) || []).map(entry => ({
                    value: entry.id,
                    text: entry.name,
                    key: entry.id
                }));
                this.setState({parcelCustomers: entries});
            })
            .catch(() => {})
            .finally(() => this.updateBusyCount(-1));
    }

    getParcelCustomerOptions() {
        return [
            {value: null, text: 'без заказчика', key: 'parcel-customer-empty'},
            ...this.state.parcelCustomers
        ];
    }

    getParcelCustomerDisplayName() {
        const id = this.props.parcel.parcelCustomerId;
        if (!id) {
            return '';
        }
        const found = this.state.parcelCustomers.find(c => c.value === id);
        return found ? found.text : (this.props.parcel.parcelCustomerName || '');
    }

    reloadReferences() {
        console.log('payerTab: reloadReferences');
        this.updateBusyCount(1);
        let loadSubCompanies = apiGet('ref/subCompanies/list/' + this.props.parcel.companyId)
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.subCompanies = data.entries.map((entry, ind, array) => { return { value: entry.id, text: entry.name, key: entry.id }; });
                    if (!this.props.parcel.subCompanyId && prevState.subCompanies.length === 1) {
                        this.handleSelectionChange('subCompanyId', prevState.subCompanies[0]);
                    }
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        let loadInitiators = Promise.resolve();
        let loadUserCompanies = Promise.resolve();

        //payerTabState
        this.updateBusyCount(1);
        let parcel = this.props.parcel;
        let stateRequest = {
            isCrossSector: parcel.isCrossSector,
            initiatorId: parcel.initiatorId,
            companyId: parcel.companyId,
            subCompanyId: parcel.subCompanyId,
            shipmentTypeId: parcel.shipmentTypeId,
            shipmentPurposeId: parcel.shipmentPurposeId
        };
        let loadControlStates = apiPost('parcels/payerTabState', stateRequest)
            .then(data => {
                this.updateBusyCount(-1);
                this.setState({ editVm: data }, () => this.notifyValidationChange());

                let isCoordinator = getRoles().indexOf('Coordinator') >= 0;
                let isOnlyBeforeSendEditable = this.props.isNew
                    || this.props.parcel.statusCode === "Created"
                    || (this.props.parcel.statusCode === "SentToMailRoom" && isCoordinator);

                let isNotCarrier = !(getRoles().indexOf('Carrier') >= 0);

                this.props.parcel.payerTabVisible = data.isVisible && (isNotCarrier || isOnlyBeforeSendEditable);

                if (data.isVisibleUserCompany && !this.isLoadingUserCompanies) {
                    loadUserCompanies = this.loadUserCompanies(parcel);
                } else { //если старая логика, где инициаторы не зависят от выбранного юр лица
                    loadInitiators = this.loadInitiators();
                }

                if (data.isVisibleParcelCustomer || parcel.parcelCustomerId) {
                    this.loadParcelCustomers();
                }

                return this.props.parcel.payerTabVisible;
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        let loadOtherRefs = this.reloadReferencesWithDependences();

        return Promise.all([loadSubCompanies, loadInitiators, loadControlStates, loadUserCompanies, loadOtherRefs]);
    }

    reloadReferencesWithDependences() {
        let parcel = this.props.parcel;
        let loadShipmentTypes = Promise.resolve();
        let loadShipmentPurposes = Promise.resolve();
        let loadProducts = Promise.resolve();
        let loadRegions = Promise.resolve();
        let loadCostCenters = Promise.resolve();
        let loadGlAccounts = Promise.resolve();

        if (this.lastSubCompanyId !== parcel.subCompanyId
            || this.lastInitiatorId !== parcel.initiatorId
            || this.lastCrossSector !== parcel.isCrossSector) {
            this.updateBusyCount(1);
            let shipmentTypesRequest = {
                isCrossSector: parcel.isCrossSector,
                subCompanyId: parcel.subCompanyId,
                companyId: parcel.companyId
            };
            loadShipmentTypes = apiPost('ref/shipmentTypes/list', shipmentTypesRequest)
                .then(data => {
                    this.updateBusyCount(-1);
                    this.setState((prevState, props) => {
                        let hasSelection = false;
                        let defaultValue = null;
                        prevState.shipmentTypes = data.entries.map((entry, ind, array) => {
                            if (entry.id === parcel.shipmentTypeId) {
                                hasSelection = true;
                            }
                            let newEntry = { value: entry.id, text: entry.name, key: entry.id };
                            if (entry.isDefault) {
                                defaultValue = newEntry;
                            }
                            return newEntry;
                        });
                        if ((parcel.shipmentTypeId === null || parcel.shipmentTypeId === undefined || !hasSelection) && defaultValue) {
                            this.handleSelectionChange('shipmentTypeId', defaultValue);
                        } else if (!isUndefined(parcel.shipmentTypeId)) {
                            if (prevState.shipmentTypes.length === 1) {
                                this.handleSelectionChange('shipmentTypeId', prevState.shipmentTypes[0]);
                            } else if (!hasSelection) {
                                this.handleSelectionChange('shipmentTypeId', null);
                            }
                        }
                        return prevState;
                    });
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                });
        }

        if (this.lastSubCompanyId !== parcel.subCompanyId
            || this.lastShipmentTypeId !== parcel.shipmentTypeId) {
            this.updateBusyCount(1);
            let shipmentPurposesRequest = {
                companyId: parcel.companyId,
                subCompanyId: parcel.subCompanyId,
                shipmentTypeId: parcel.shipmentTypeId
            };
            loadShipmentPurposes = apiPost('ref/shipmentPurposes/list', shipmentPurposesRequest)
                .then(data => {
                    this.updateBusyCount(-1);
                    this.setState((prevState, props) => {
                        let hasSelection = false;
                        prevState.shipmentPurposes = data.entries.map((entry, ind, array) => {
                            if (entry.id === parcel.shipmentPurposeId) {
                                hasSelection = true;
                            }
                            return { value: entry.id, text: entry.name, key: entry.id };
                        });
                        if (!isUndefined(parcel.shipmentPurposeId)) {
                            if (prevState.shipmentPurposes.length === 1) {
                                this.handleSelectionChange('shipmentPurposeId', prevState.shipmentPurposes[0]);
                            } else if (!hasSelection) {
                                this.handleSelectionChange('shipmentPurposeId', null);
                            }
                        }
                        return prevState;
                    });
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                });
        }

        if (this.lastSubCompanyId !== parcel.subCompanyId
            || this.lastShipmentTypeId !== parcel.shipmentTypeId
            || this.lastCostCenterId !== parcel.costCenterId) {
            this.updateBusyCount(1);
            let regionsRequest = {
                companyId: parcel.companyId,
                subCompanyId: parcel.subCompanyId,
                shipmentTypeId: parcel.shipmentTypeId,
                costCenterId: parcel.costCenterId
            };
            loadRegions = apiPost('ref/regions/list', regionsRequest)
                .then(data => {
                    this.updateBusyCount(-1);
                    this.setState((prevState, props) => {
                        let hasSelection = false;
                        const regionsMeta = {};
                        prevState.regions = data.entries.map((entry, ind, array) => {
                            if (entry.id === parcel.regionId) {
                                hasSelection = true;
                            }
                            regionsMeta[entry.id] = {code: entry.code};
                            return { value: entry.id, text: entry.name, key: entry.id };
                        });
                        prevState.regionsMeta = regionsMeta;
                        if (!isUndefined(parcel.regionId)) {
                            if (prevState.regions.length === 1) {
                                this.handleSelectionChange('regionId', prevState.regions[0]);
                            } else if (!hasSelection) {
                                this.handleSelectionChange('regionId', null);
                            }
                        }
                        return prevState;
                    });
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                });
        }

        if (this.lastSubCompanyId !== parcel.subCompanyId
            || this.lastShipmentTypeId !== parcel.shipmentTypeId
            //|| this.lastShipmentPurposeId !== parcel.shipmentPurposeId
            || this.lastProductId !== parcel.productId
            || this.lastInitiatorId !== parcel.initiatorId
            || this.lastCrossSector !== parcel.isCrossSector) {
            this.updateBusyCount(1);
            let costCentersRequest = {
                isCrossSector: parcel.isCrossSector,
                companyId: parcel.companyId,
                subCompanyId: parcel.subCompanyId,
                shipmentTypeId: parcel.shipmentTypeId,
                shipmentPurposeId: parcel.shipmentPurposeId,
                productId: parcel.productId,
                userId: parcel.initiatorId
            };
            loadCostCenters = apiPost('ref/costCenters/list', costCentersRequest)
                .then(data => {
                    this.updateBusyCount(-1);
                    this.setState((prevState, props) => {
                        let hasSelection = false;
                        let defaultValue = null;
                        prevState.costCenters = data.entries.map((entry, ind, array) => {
                            if (entry.id === parcel.costCenterId) {
                                hasSelection = true;
                            }
                            let newValue = { value: entry.id, text: entry.name, key: entry.id };
                            if (entry.isDefault) {
                                defaultValue = newValue;
                            }
                            return newValue;
                        });
                        if (defaultValue) {
                            this.handleSelectionChange('costCenterId', defaultValue);
                        }
                        return prevState;
                    });
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                });
            this.updateBusyCount(1);
            let glAccountsRequest = {
                companyId: parcel.companyId,
                subCompanyId: parcel.subCompanyId,
                shipmentTypeId: parcel.shipmentTypeId,
                shipmentPurposeId: parcel.shipmentPurposeId
            };
            loadGlAccounts = apiPost('ref/glAccounts/list', glAccountsRequest)
                .then(data => {
                    this.updateBusyCount(-1);
                    this.setState((prevState, props) => {
                        let hasSelection = false;
                        const glAccountsMeta = {};
                        prevState.glAccounts = data.entries.map((entry, ind, array) => {
                            if (entry.id === parcel.glAccountId) {
                                hasSelection = true;
                            }
                            glAccountsMeta[entry.id] = {activityCode: entry.activityCode};
                            return { value: entry.id, text: entry.name, key: entry.id };
                        });
                        prevState.glAccountsMeta = glAccountsMeta;
                        if (!isUndefined(parcel.glAccountId)) {
                            if (prevState.glAccounts.length === 1) {
                                this.handleSelectionChange('glAccountId', prevState.glAccounts[0]);
                            } else if (!hasSelection) {
                                this.handleSelectionChange('glAccountId', null);
                            }
                        }
                        return prevState;
                    });
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                });
        }

        if (this.lastSubCompanyId !== parcel.subCompanyId
            || this.lastShipmentTypeId !== parcel.shipmentTypeId
            || this.lastShipmentPurposeId !== parcel.shipmentPurposeId) {

            this.updateBusyCount(1);
            let productsRequest = {
                companyId: parcel.companyId,
                subCompanyId: parcel.subCompanyId,
                shipmentTypeId: parcel.shipmentTypeId,
                shipmentPurposeId: parcel.shipmentPurposeId
            };
            loadProducts = apiPost('ref/products/list/', productsRequest)
                .then(data => {
                    this.updateBusyCount(-1);
                    this.setState((prevState, props) => {
                        let hasSelection = false;
                        let defaultValue = null;
                        const productsMeta = {};
                        prevState.products = data.entries.map((entry, ind, array) => {
                            if (entry.id === parcel.productId) {
                                hasSelection = true;
                            }
                            productsMeta[entry.id] = {activityCode: entry.activityCode};
                            let newValue = { value: entry.id, text: entry.name, key: entry.id };
                            if (entry.isDefault) {
                                defaultValue = newValue;
                            }
                            return newValue;
                        });
                        prevState.productsMeta = productsMeta;
                        if (defaultValue && parcel.productId !== defaultValue.value) {
                            this.handleSelectionChange('productId', defaultValue);
                        } else if (!isUndefined(parcel.productId)) {
                            if (prevState.products.length === 1) {
                                this.handleSelectionChange('productId', prevState.products[0]);
                            } else if (!hasSelection) {
                                this.handleSelectionChange('productId', null);
                            }
                        }
                        return prevState;
                    });
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                });
        }

        this.lastCrossSector = parcel.isCrossSector;
        this.lastSubCompanyId = parcel.subCompanyId;
        this.lastShipmentTypeId = parcel.shipmentTypeId;
        this.lastShipmentPurposeId = parcel.shipmentPurposeId;
        this.lastProductId = parcel.productId;
        this.lastInitiatorId = parcel.initiatorId;
        this.lastCostCenterId = parcel.costCenterId;

        return Promise.all([loadShipmentPurposes, loadShipmentTypes, loadProducts, loadRegions, loadCostCenters, loadGlAccounts]);
    }

    loadInitiators() {
        let currentUserId = getCurrentUserId();
        this.updateBusyCount(1);
        return apiGet('ref/users/initiators/' + this.props.parcel.companyId)
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState) => {
                    const initiatorsMeta = {};
                    prevState.initiators = data.entries
                        .filter((entry) => !this.props.isNew || !entry.isBlocked)
                        .map((entry, ind, array) => {
                            initiatorsMeta[entry.id] = {
                                subCompanyId: entry.subCompanyId,
                                isCrossSector: entry.isCrossSector
                            };
                            if (this.props.isNew && (entry.id === currentUserId || entry.isDefault)) {
                                let fieldsChanges = [
                                    {
                                        name: "initiatorId",
                                        value: entry.id
                                    },
                                    {
                                        name: "isCrossSector",
                                        value: entry.isCrossSector
                                    },
                                    {
                                        name: "subCompanyId",
                                        value: entry.subCompanyId
                                    },
                                    {
                                        name: "initiatorIsCrossSector",
                                        value: entry.isCrossSector
                                    },
                                    {
                                        name: "initiatorSubCompanyId",
                                        value: entry.subCompanyId
                                    }
                                ];
                                this.props.onFieldChange(fieldsChanges)
                                    .then(() => {
                                        if (this.props.isNew) {
                                            this.reloadReferencesWithDependences();
                                        }
                                    });
                            }
                            return {
                                value: entry.id,
                                text: entry.fullName,
                                key: entry.id
                            };
                        });
                    prevState.initiatorsMeta = initiatorsMeta;
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });
    }

    loadUserCompanies(parcel) {
        this.isLoadingUserCompanies = true;
        this.updateBusyCount(1);
        let request = {
            userId: getCurrentUserId()
        }
        return apiPost('ref/usercompanies/list', request)
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    let hasSelection = false;
                    let currentUserCompanyId = getCurrentUserCompanyId();
                    prevState.userCompanies = data.entries.map((entry, ind, array) => {
                        if (this.props.isNew && (currentUserCompanyId !== undefined && entry.companyId === currentUserCompanyId)) {
                            let fieldsChanges = [
                                {
                                    name: "userCompanyId",
                                    value: entry.companyId
                                }
                            ];
                            this.props.onFieldChange(fieldsChanges);
                        }
                        if (entry.companyId === parcel.userCompanyId) {
                            hasSelection = true;
                        }
                        return { value: entry.companyId, text: entry.name, key: entry.companyId };
                    });
                    if (!isUndefined(parcel.userCompanyId)) {
                        if (prevState.userCompanies.length > 0 && !hasSelection) {
                        } else if (!hasSelection) {
                            this.handleSelectionChange('userCompanyId', null);
                        }
                    }
                    this.loadInitiatorsByCompany(this.props.parcel.userCompanyId);
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });
    }

    loadInitiatorsByCompany(companyId) {
        let currentUserId = getCurrentUserId();
        this.updateBusyCount(1);
        return apiGet('ref/users/initiators/' + companyId)
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.userCompanyInitiators = data.entries.map((entry, ind, array) => {
                        if (this.props.isNew && (entry.id === currentUserId || entry.isDefault)) {
                            let fieldsChanges = [
                                {
                                    name: "initiatorId",
                                    value: entry.id
                                }
                            ];
                            this.props.onFieldChange(fieldsChanges)
                                .then(() => {
                                    if (this.props.isNew) {
                                        this.reloadReferencesWithDependences();
                                    }
                                });
                        }
                        return {
                            value: entry.id,
                            text: entry.fullName,
                            key: entry.id
                        };
                    });
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });
    }

    fillModel(parcel) {
        parcel.initiatorId = this.props.parcel.initiatorId;
        parcel.isCrossSector = this.props.parcel.isCrossSector;
        parcel.subCompanyId = this.props.parcel.subCompanyId;
        parcel.shipmentTypeId = this.props.parcel.shipmentTypeId;
        parcel.shipmentPurposeId = this.props.parcel.shipmentPurposeId;
        parcel.productId = this.props.parcel.productId;
        parcel.regionId = this.props.parcel.regionId;
        parcel.costCenterId = this.props.parcel.costCenterId;
        parcel.glAccountId = this.props.parcel.glAccountId;
        parcel.parcelCustomerId = this.props.parcel.parcelCustomerId;
        parcel.userCompanyId = this.props.parcel.userCompanyId;
        return parcel;
    }

    isNextStepAvailable() {
        let errors = this.validateForm();
        if (errors === null)
            return true;
        return false;
    }

    hasFormErrors(errors) {
        return !isUndefined(errors)
            && (errors.initiatorId
                || errors.subCompanyId
                || errors.shipmentTypeId
                || errors.shipmentPurposeId
                || errors.productId
                || errors.regionId
                || errors.costCenterId
                || errors.glAccountId
                || errors.parcelCustomerId
                || errors.userCompanyId);
    }

    validateForm(fieldName) {
        var result = null;

        if (!this.props.parcel.payerTabVisible)
            return null;

        if (this.state.editVm.isRequiredInitiator && (isUndefined(fieldName) || fieldName === "initiatorId")) {
            if (!this.props.parcel.initiatorId) {
                result = result ? result : {};
                result.initiatorId = "Инициатор является обязательным полем";
            }
        }

        if (this.state.editVm.isRequiredSubCompany && (isUndefined(fieldName) || fieldName === "subCompanyId")) {
            if (!this.props.parcel.subCompanyId) {
                result = result ? result : {};
                result.subCompanyId = "Сектор является обязательным полем";
            }
        }

        if (this.state.editVm.isRequiredShipmentType && (isUndefined(fieldName) || fieldName === "shipmentTypeId")) {
            if (!this.props.parcel.shipmentTypeId) {
                result = result ? result : {};
                result.shipmentTypeId = "Цель отправки является обязательным полем";
            }
        }

        if (this.state.editVm.isRequiredShipmentPurpose && (isUndefined(fieldName) || fieldName === "shipmentPurposeId")) {
            if (!this.props.parcel.shipmentPurposeId) {
                result = result ? result : {};
                result.shipmentPurposeId = "Тип отправки является обязательным полем";
            }
        }

        if (this.state.editVm.isRequiredProduct && (isUndefined(fieldName) || fieldName === "productId")) {
            if (!this.props.parcel.productId) {
                result = result ? result : {};
                result.productId = "Продукт является обязательным полем";
            }
        }

        if (this.state.editVm.isRequiredRegion && (isUndefined(fieldName) || fieldName === "regionId")) {
            if (!this.props.parcel.regionId) {
                result = result ? result : {};
                result.regionId = "Регион является обязательным полем";
            }
        }

        if (this.state.editVm.isRequiredCostCenter && (isUndefined(fieldName) || fieldName === "costCenterId")) {
            if (!this.props.parcel.costCenterId) {
                result = result ? result : {};
                result.costCenterId = "Кост-центр является обязательным полем";
            }
        }

        if (this.state.editVm.isRequiredGlAccount && (isUndefined(fieldName) || fieldName === "glAccountId")) {
            if (!this.props.parcel.glAccountId) {
                result = result ? result : {};
                result.glAccountId = "GL аккаунт является обязательным полем";
            }
        }

        if (this.state.editVm.isVisibleParcelCustomer
            && this.state.editVm.isRequiredParcelCustomer
            && this.isParcelCustomerEditable()
            && (isUndefined(fieldName) || fieldName === "parcelCustomerId")) {
            if (!this.props.parcel.parcelCustomerId) {
                result = result ? result : {};
                result.parcelCustomerId = "Заказчик является обязательным полем";
            }
        }

        if (this.state.editVm.isRequiredUserCompany && (isUndefined(fieldName) || fieldName === "userCompanyId")) {
            if (!this.props.parcel.userCompanyId) {
                result = result ? result : {};
                result.userCompanyId = "Юр лицо является обязательным полем";
            }
        }
        return result;
    }

    getFieldsChanges(name, selection, isSelection) {
        let newValue = isSelection ? (selection ? selection.value : null) : selection;
        let fieldsChanges = [
            {
                name: name,
                value: newValue
            }
        ];

        if (name === 'userCompanyId') {
            fieldsChanges.push({
                name: 'initiatorId',
                value: null
            });
        }

        if (name === 'initiatorId') {
            const initiatorMeta = newValue != null ? (this.state.initiatorsMeta[newValue] || {}) : {};
            fieldsChanges.push({
                name: 'isCrossSector',
                value: !!initiatorMeta.isCrossSector
            });
            if (newValue != null) {
                fieldsChanges.push({
                    name: 'subCompanyId',
                    value: initiatorMeta.subCompanyId
                });
            }
            fieldsChanges.push({
                name: 'initiatorIsCrossSector',
                value: !!initiatorMeta.isCrossSector
            });
            fieldsChanges.push({
                name: 'initiatorSubCompanyId',
                value: initiatorMeta.subCompanyId != null ? initiatorMeta.subCompanyId : null
            });
        } else if (name === 'regionId') {
            const regionMeta = newValue != null ? (this.state.regionsMeta[newValue] || {}) : {};
            fieldsChanges.push({
                name: 'regionCode',
                value: regionMeta.code || ""
            });
        } else if (name === 'productId') {
            const productMeta = newValue != null ? (this.state.productsMeta[newValue] || {}) : {};
            fieldsChanges.push({
                name: 'activityCode',
                value: productMeta.activityCode || ""
            });
        } else if (name === 'isCrossSector' && !newValue) {
            fieldsChanges.push({
                name: 'subCompanyId',
                value: this.props.parcel.initiatorSubCompanyId
            });
        }

        return fieldsChanges;
    }

    handleSelectionChange(name, selection, ignoreValidation) {
        let newValue = selection ? selection.value : null;

        const statesByName = {
            shipmentTypeId: ['shipmentTypes'],
            shipmentPurposeId: ['shipmentPurposes'],
            costCenterId: ['costCenters'],
            parcelCustomerId: ['parcelCustomers'],
            glAccountId: ['glAccounts'],
            regionId: ['regions'],
            productId: ['products'],
            initiatorId: ['initiators', 'userCompanyInitiators'],
            subCompanyId: ['subCompanies'],
        };

        if (Object.keys(statesByName).includes(name)) {
            let items = [];
            statesByName[name].forEach(v => items = [...items, ...(this.state[v] || [])]);
            selection = items.find(i => i.value === selection.value);
        }

        let fieldsChanges = this.getFieldsChanges(name, selection, true);
        return this.props.onFieldChange(fieldsChanges)
            .then(() => {
                this.handleFieldEdited(name, newValue);
                this.notifyValidationChange();
                if (this.props.isNew) {
                    this.reloadReferencesWithDependences();
                }
            });
    }

    handleInputEdited(name, value) {
        let fieldsChanges = this.getFieldsChanges(name, value, false);
        this.props.onFieldChange(fieldsChanges)
            .then(() => {
                this.handleFieldEdited(name, value);
                if (this.props.isNew && name === "isCrossSector") {
                    this.reloadReferencesWithDependences();
                }
            });
    }

    handleFieldEdited(name, value, ignoreValidation) {
        if (this.props.onFieldEdited) {
            this.props.onFieldEdited(name, value, ignoreValidation);
        }
    }

    handleUserCompanyEdited(e) {
        this.handleSelectionChange("userCompanyId", e)
            .then(data => {
                this.handleFieldEdited("initiatorId", null, true);
                this.loadInitiatorsByCompany(this.props.parcel.userCompanyId);
            });
    }

    renderShipmentType(isVisible, isRequired, isBusy, isOnlyBeforeSendEditable) {
        const {
            parcel,
            errors
        } = this.props;

        if (isVisible) {
            return (
                <Form.Field error={errors.shipmentTypeId}>
                    <label>
                        Тип отправки {isRequired && <span className="text-red">*</span>}
                    </label>
                    <Dropdown
                        onChange={(event, e) => this.handleSelectionChange("shipmentTypeId", e)}
                        disabled={isBusy || !isOnlyBeforeSendEditable || !this.state.editVm.canEditShipmentType || (this.props.parcel && this.props.parcel.statusCode === 'Processing')}
                        name={'shipmentTypeId'}
                        value={parcel.shipmentTypeId}
                        options={this.state.shipmentTypes}
                    />
                </Form.Field>
            );
        }

        return null;
    }

    renderShipmentPurpose(isVisible, isRequired, isBusy, isOnlyBeforeSendEditable) {
        const {
            parcel,
            errors
        } = this.props;

        if (isVisible) {
            return (
                <Form.Field error={errors.shipmentPurposeId}>
                    <label>
                        Тип/цель отправки
                        {isRequired && <span className="text-red">*</span>}
                        <Info
                            name={'Цель отправки'}
                            text={'Цель отправки'}
                        />
                    </label>
                    <Dropdown
                        onChange={(event, e) => this.handleSelectionChange("shipmentPurposeId", e)}
                        disabled={isBusy || !isOnlyBeforeSendEditable || !this.state.editVm.canEditShipmentPurpose || (this.props.parcel && this.props.parcel.statusCode === 'Processing')}
                        name={'shipmentPurposeId'}
                        value={parcel.shipmentPurposeId}
                        options={this.state.shipmentPurposes}
                    />
                </Form.Field>
            );
        }

        return null;
    }

    renderParcelCustomer(isBusy) {
        const {parcel, errors} = this.props;
        if (!this.shouldShowParcelCustomer()) {
            return null;
        }

        const isRequired = this.state.editVm.isRequiredParcelCustomer;
        const isEditable = this.isParcelCustomerEditable();

        if (!isEditable) {
            const canManage = this.canManageParcelCustomers();
            return (
                <Form.Field>
                    <label>Заказчик</label>
                    <div style={{display: 'flex', gap: 8, alignItems: 'center'}}>
                        <div style={{flex: 1}}>
                            <Input value={this.getParcelCustomerDisplayName()} disabled />
                        </div>
                        {canManage && (
                            <Button type="button" onClick={() => this.setState({parcelCustomersModalOpen: true})} disabled={isBusy}>
                                Добавить/Удалить
                            </Button>
                        )}
                    </div>
                </Form.Field>
            );
        }

        return (
            <Form.Field error={errors.parcelCustomerId}>
                <label>
                    Заказчик {isRequired && <span className="text-red">*</span>}
                    <Info text="Укажите наименование вашего контрагента, если нужно" />
                </label>
                <div style={{display: 'flex', gap: 8, alignItems: 'center'}}>
                    <div style={{flex: 1}}>
                        <Dropdown
                            onChange={(event, e) => this.handleSelectionChange("parcelCustomerId", e)}
                            disabled={isBusy || !this.isParcelCustomerEditable()}
                            name={'parcelCustomerId'}
                            value={parcel.parcelCustomerId}
                            options={this.getParcelCustomerOptions()}
                        />
                    </div>
                    {this.canManageParcelCustomers() && (
                        <Button type="button" onClick={() => this.setState({parcelCustomersModalOpen: true})} disabled={isBusy}>
                            Добавить/Удалить
                        </Button>
                    )}
                </div>
            </Form.Field>
        );
    }

    renderCostCenter(isVisible, isRequired, isBusy) {
        const {
            parcel,
            errors
        } = this.props;

        if (isVisible) {
            return (
                <Form.Field error={errors.costCenterId}>
                    <label>
                        Кост центр {isRequired && <span className="text-red">*</span>}
                    </label>
                    <Dropdown
                        onChange={(event, e) => this.handleSelectionChange("costCenterId", e)}
                        disabled={isBusy || !this.state.editVm.canEditCostCenter || (this.props.parcel && this.props.parcel.statusCode === 'Processing')}
                        name={'costCenterId'}
                        value={parcel.costCenterId}
                        options={this.state.costCenters}
                    />
                </Form.Field>
            );
        }

        return null;
    }

    renderGlAccount(isVisible, isRequired, isBusy) {
        const {
            parcel,
            errors
        } = this.props;

        if (isVisible) {
            return (
                <Form.Field error={errors.glAccountId}>
                    <label>
                        GL аккаунт {isRequired && <span className="text-red">*</span>}
                    </label>
                    <Dropdown
                        onChange={(event, e) => this.handleSelectionChange("glAccountId", e)}
                        disabled={isBusy || !this.state.editVm.canEditGlAccount || (this.props.parcel && this.props.parcel.statusCode === 'Processing')}
                        name={'glAccountId'}
                        value={parcel.glAccountId}
                        options={this.state.glAccounts}
                    />
                </Form.Field>
            );
        }

        return null;
    }

    renderRegion(isVisible, isRequired, isBusy) {
        const {
            parcel,
            errors
        } = this.props;

        if (isVisible) {
            return (
                <div>
                    <Form.Field error={errors.regionId}>
                        <label>
                            Регион {isRequired && <span className="text-red">*</span>}
                        </label>
                        <Dropdown
                            onChange={(event, e) => this.handleSelectionChange("regionId", e)}
                            disabled={isBusy || !this.state.editVm.canEditRegion || (this.props.parcel && this.props.parcel.statusCode === 'Processing')}
                            name={'regionId'}
                            value={parcel.regionId}
                            options={this.state.regions}
                        />
                    </Form.Field>
                    <Form.Field>
                        <label>
                            Код региона
                            <Info
                                name={'Код региона'}
                                text={'Код региона - финансовый код региона'}
                            />
                        </label>
                        <Input
                            value={parcel.regionCode || ''}
                            disabled
                        />
                    </Form.Field>
                </div>
            );
        }

        return null;
    }

    renderProduct(isVisible, isRequired, isBusy) {
        const {
            parcel,
            errors
        } = this.props;

        if (isVisible) {
            return (
                <Form.Field>
                    <Form.Field error={errors.productId}>
                        <label>
                            Клиент/продукт {isRequired && <span className="text-red">*</span>}
                        </label>
                        <Dropdown
                            onChange={(event, e) => this.handleSelectionChange("productId", e)}
                            disabled={isBusy || !this.state.editVm.canEditProduct || (this.props.parcel && this.props.parcel.statusCode === 'Processing')}
                            name={'productId'}
                            value={parcel.productId}
                            options={this.state.products}
                        />
                    </Form.Field>
                    <Form.Field>
                        <label>
                            Активити код
                        </label>
                        <Input
                            value={parcel.activityCode || ''}
                            disabled
                        />
                    </Form.Field>
                </Form.Field>
            );
        }

        return null;
    }

    renderUserCompany(isVisible, isRequired, isBusy, isOnlyBeforeSendEditable) {
        const {
            parcel,
            errors
        } = this.props;

        if (isVisible) {
            return (
                <Form.Field error={errors.userCompanyId}>
                    <label>
                        Юр лицо {isRequired && <span className="text-red">*</span>}
                    </label>
                    <Dropdown
                        onChange={(event, e) => this.handleUserCompanyEdited(e)}
                        disabled={isBusy || !isOnlyBeforeSendEditable || !this.state.editVm.canEditUserCompany || (this.props.parcel && this.props.parcel.statusCode === 'Processing')}
                        name={'userCompanyId'}
                        value={parcel.userCompanyId}
                        options={this.state.userCompanies}
                    />
                </Form.Field>
            );
        }

        return null;
    }

    renderInitiator(isVisible, isRequired, isBusy, isOnlyBeforeSendEditable, isVisibleCrossSector) {
        const {
            parcel,
            errors
        } = this.props;

        if (isVisible) {
            const isGlobalAdmin = getRoles().indexOf('GlobalAdmin') >= 0;
            
            return (
                <div>
                    <Form.Field error={errors.initiatorId}>
                        <label>
                            Плательщик {isRequired && <span className="text-red">*</span>}
                            <Info
                                name={'Плательщик'}
                                text={'Плательщик - это тот, кто платит за отправку'}
                            />
                        </label>
                        {isGlobalAdmin && isOnlyBeforeSendEditable && this.state.editVm.canEditInitiator ? (
                            <InitiatorSearchDropdown
                                onChange={(name, value) => {
                                    const selection = value ? { value: value } : null;
                                    this.handleSelectionChange("initiatorId", selection);
                                }}
                                disabled={isBusy || !isOnlyBeforeSendEditable || !this.state.editVm.canEditInitiator || (this.props.parcel && this.props.parcel.statusCode === 'Processing')}
                                name={'initiatorId'}
                                value={parcel.initiatorId}
                                placeholder="Введите логин для поиска"
                                error={errors.initiatorId}
                            />
                        ) : (
                            <Dropdown
                                onChange={(event, e) => this.handleSelectionChange("initiatorId", e)}
                                disabled={isBusy || !isOnlyBeforeSendEditable || !this.state.editVm.canEditInitiator || (this.props.parcel && this.props.parcel.statusCode === 'Processing')}
                                name={'initiatorId'}
                                value={parcel.initiatorId}
                                options={this.state.initiators}
                            />
                        )}
                    </Form.Field>
                </div>

            );
        }

        return null;
    }

    renderSubCompany(isVisible, isRequired, isBusy, isOnlyBeforeSendEditable) {
        const {
            parcel,
            errors
        } = this.props;

        if (isVisible) {
            return (
                <Form.Field error={errors.subCompanyId}>
                    <label>
                        Сектор {isRequired && <span className="text-red">*</span>}
                    </label>
                    <Dropdown
                        onChange={(event, e) => this.handleSelectionChange("subCompanyId", e)}
                        disabled={isBusy || !isOnlyBeforeSendEditable || !this.state.editVm.canEditSubCompany || (this.props.parcel && this.props.parcel.statusCode === 'Processing')}
                        name={'subCompanyId'}
                        value={parcel.subCompanyId}
                        options={this.state.subCompanies}
                    />
                </Form.Field>
            );
        }

        return null;
    }

    renderInitiatorByUserCompanies(isVisible, isRequired, isBusy, isOnlyBeforeSendEditable) {
        const {
            parcel,
            errors
        } = this.props;

        if (isVisible) {
            const isGlobalAdmin = getRoles().indexOf('GlobalAdmin') >= 0;
            
            return (
                <Form.Field error={errors.initiatorId}>
                    <label>
                        Плательщик {isRequired && <span className="text-red">*</span>}
                        <Info
                            name={'Плательщик'}
                            text={'Плательщик - это тот, кто платит за отправку'}
                        />
                    </label>
                    {isGlobalAdmin ? (
                        <InitiatorSearchDropdown
                            onChange={(name, value) => {
                                const selection = value ? { value: value } : null;
                                this.handleSelectionChange("initiatorId", selection);
                            }}
                            disabled={isBusy || !isOnlyBeforeSendEditable || !this.state.editVm.canEditInitiator || (this.props.parcel && this.props.parcel.statusCode === 'Processing')}
                            name={'initiatorId'}
                            value={parcel.initiatorId}
                            placeholder="Введите логин для поиска"
                            error={errors.initiatorId}
                        />
                    ) : (
                        <Dropdown
                            onChange={(event, e) => this.handleSelectionChange("initiatorId", e)}
                            disabled={isBusy || !isOnlyBeforeSendEditable || !this.state.editVm.canEditInitiator || (this.props.parcel && this.props.parcel.statusCode === 'Processing')}
                            name={'initiatorId'}
                            value={parcel.initiatorId}
                            options={this.state.userCompanyInitiators}
                        />
                    )}
                </Form.Field>
            );
        }

        return null;
    }

    render() {
        let isCoordinator = getRoles().indexOf('Coordinator') >= 0;
        let isOnlyBeforeSendEditable = this.props.isNew
            || this.props.parcel.statusCode === "Created"
            || (this.props.parcel.statusCode === "SentToMailRoom" && isCoordinator);
        let isBusy = this.props.isBusy || this.state.busyCount > 0;

        const {
            errors,
            parcel
        } = this.props;

        return (
            <SectionForm
                label='Плательщик'
                icon={<svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_32_6508)">
                        <path d="M29.8177 -0.000227769C29.9449 0.0476889 30.07 0.103939 30.1982 0.143522C30.7125 0.320383 31.1615 0.658928 31.4831 1.11248C31.8048 1.56603 31.9833 2.11224 31.9941 2.67581C32.0011 3.02269 31.9941 3.3706 31.9941 3.73623H0.0391089C-0.0940326 2.39561 0.0651368 1.18623 1.27042 0.412272C1.55172 0.232064 1.88207 0.135189 2.18939 -0.00439453L29.8177 -0.000227769Z" fill="#1F64AD"/>
                        <path d="M10.9738 40C10.3431 39.699 10.1079 39.1917 10.1349 38.4708C10.1739 37.4198 10.1449 36.3656 10.1449 35.3115V34.874H21.8653V36.5625C21.8653 37.1875 21.8343 37.8125 21.8734 38.4375C21.9184 39.1667 21.6902 39.699 21.0365 40.0052L10.9738 40Z" fill="#1F64AD"/>
                        <path d="M0.0112305 6.11981H31.9992V6.52606C31.9992 10.1323 31.9992 13.7379 31.9992 17.3427C31.9992 19.0469 30.878 20.2167 29.2473 20.224C28.4985 20.224 27.7507 20.224 26.9629 20.224C26.9539 20.0438 26.9418 19.8938 26.9408 19.7438C26.9278 18.6375 26.9719 17.5271 26.8958 16.4261C26.7356 14.099 24.7635 12.2677 22.4911 12.2698C20.2187 12.2719 18.2586 14.1136 18.1014 16.4365C18.0284 17.525 18.0704 18.624 18.0614 19.7146C18.0614 19.8677 18.0614 20.0209 18.0614 20.2209H2.83223C1.12041 20.2209 0.0122315 19.075 0.0112305 17.2927C0.0112305 13.7136 0.0112305 10.134 0.0112305 6.55419V6.11981ZM7.63133 16.2156C8.5443 16.2156 9.45727 16.2219 10.3702 16.2156C11.2011 16.2084 11.6426 15.7406 11.6446 14.8823C11.6446 13.3455 11.6446 11.8097 11.6446 10.275C11.6446 9.41565 11.1971 8.9396 10.3722 8.93648C8.5463 8.93023 6.72036 8.93023 4.89442 8.93648C4.06754 8.93648 3.62207 9.4146 3.62006 10.2729C3.62006 11.7952 3.62006 13.3177 3.62006 14.8406C3.62006 15.7511 4.05553 16.2115 4.92946 16.2167C5.82941 16.2198 6.73037 16.2156 7.63133 16.2156Z" fill="#1F64AD"/>
                        <path d="M7.35998 22.5865H16.3696C16.2935 22.6958 16.2444 22.7771 16.1854 22.851C15.0261 24.3021 14.4836 25.9761 14.4836 27.8563C14.4836 28.5417 14.936 29.0479 15.5527 29.0698C16.1693 29.0917 16.6629 28.6354 16.7289 27.9573C16.771 27.5177 16.767 27.0688 16.8571 26.6406C17.2044 24.9948 18.1144 23.7667 19.5389 22.9792C20.0835 22.6781 20.3177 22.2656 20.3117 21.6385C20.2977 20.0892 20.2977 18.5403 20.3117 16.9917C20.3218 15.7583 21.0175 14.875 22.1207 14.6542C22.4045 14.6023 22.6955 14.6098 22.9766 14.6764C23.2576 14.7429 23.5231 14.8671 23.7574 15.0417C23.9918 15.2163 24.1903 15.4378 24.3414 15.6932C24.4925 15.9486 24.5931 16.2328 24.6373 16.5292C24.662 16.7093 24.6747 16.891 24.6754 17.0729C24.6754 20.7698 24.6874 24.4688 24.6754 28.1635C24.6684 30.1188 23.8135 31.5427 22.0996 32.376C21.9063 32.4642 21.6971 32.5086 21.486 32.5063C17.8328 32.5132 14.1799 32.5132 10.5273 32.5063C10.2916 32.5056 10.0588 32.4523 9.84462 32.35C8.26394 31.5625 7.39402 30.2375 7.34096 28.4115C7.28991 26.5365 7.32694 24.6615 7.32694 22.7865C7.33286 22.719 7.34391 22.6521 7.35998 22.5865Z" fill="#459EFF"/>
                        <path d="M9.36407 13.8458H5.90039V11.3031H9.36407V13.8458Z" fill="#459EFF"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_32_6508">
                            <rect width="32" height="40" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>}
            >
                {
                    this.state.editVm.isVisibleUserCompany && <Form>
                        <Grid>
                            <Grid.Row columns={16}>
                                <Grid.Column width={8}>
                                    {this.renderUserCompany(true, this.state.editVm.isRequiredUserCompany, isBusy, isOnlyBeforeSendEditable)}
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    {this.renderInitiatorByUserCompanies(this.state.editVm.isVisibleInitiator, this.state.editVm.isRequiredInitiator, isBusy, isOnlyBeforeSendEditable)}
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row columns={16}>
                                <Grid.Column width={8}>
                                    {this.renderParcelCustomer(isBusy)}
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Form>
                }
                {
                    !this.state.editVm.isVisibleUserCompany && <Form>
                        <Grid>
                            <Grid.Row columns={16}>
                                <Grid.Column width={8}>
                                    {this.renderInitiator(this.state.editVm.isVisibleInitiator, this.state.editVm.isRequiredInitiator, isBusy, isOnlyBeforeSendEditable, true)}
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    {this.renderSubCompany(this.state.editVm.isVisibleSubCompany, this.state.editVm.isRequiredSubCompany, isBusy, isOnlyBeforeSendEditable)}
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row columns={16}>
                                <Grid.Column width={8}>
                                    {this.renderShipmentType(this.state.editVm.isVisibleShipmentType, this.state.editVm.isRequiredShipmentType, isBusy, isOnlyBeforeSendEditable)}
                                    {this.renderShipmentPurpose(this.state.editVm.isVisibleShipmentPurpose, this.state.editVm.isRequiredShipmentPurpose, isBusy, isOnlyBeforeSendEditable)}
                                    {this.renderRegion(this.state.editVm.isVisibleRegion, this.state.editVm.isRequiredRegion, isBusy)}
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    {this.renderProduct(this.state.editVm.isVisibleProduct, this.state.editVm.isRequiredProduct, isBusy)}
                                    {this.renderCostCenter(this.state.editVm.isVisibleCostCenter, this.state.editVm.isRequiredCostCenter, isBusy)}
                                    {this.renderGlAccount(this.state.editVm.isVisibleGlAccount, this.state.editVm.isRequiredGlAccount, isBusy)}
                                    {this.renderParcelCustomer(isBusy)}
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Form>
                }
                <ParcelCustomersManageModal
                    open={this.state.parcelCustomersModalOpen}
                    companyId={parcel.companyId}
                    onClose={() => this.setState({parcelCustomersModalOpen: false})}
                    onChanged={() => this.loadParcelCustomers().then(() => this.notifyValidationChange())}
                />
            </SectionForm>
        )
    }
}


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/tabs/payerTab.jsx